import React, { Component } from 'react'
import PropTypes from "prop-types";

import _ from "lodash";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";
import Business from '@material-ui/icons/Business';
import DateRange from '@material-ui/icons/DateRange';


import {
  Container,
  Row,
  Col,
  Spinner,
} from 'reactstrap';

// core components
import Button from "components/CustomButtons/Button.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FileUpload from "components/CustomUpload/FileUpload";

// helpers
import { uploadFile } from "helpers/storage";
import { uuidv4 } from "helpers/math";
import { createOrg } from "helpers/https";
import { verifyEmail, verifyPhoneNumber, verifyNumber, verifyLength } from "components/Form/DXFormValidator";

// database
import { updateOrg } from 'db';

// styles
import registerPageStyle from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import CustomDropdown from 'components/CustomDropdown/CustomDropdown';
import { ORG_STATUS_STRING, ORG_STATUS } from 'constants/org';
import { newOrgId } from 'db';
import { verifyDate } from 'components/Form/DXFormValidator';
import { getFirebaseStorgeFilenameFromURL } from 'helpers/storage';

const styles = {
  ...registerPageStyle,
  container: {
    backgroundColor: "white",
    padding: "3em 0 4em 0"
  }
};

class OrgForm extends Component {

  constructor(props) {
    super(props);
    if (props.org) {
      const org = props.org.data();
      const {
        기관명,
        대표자이름,
        대표전화,
        사업장주소,
        대표이메일,
        비밀번호 = "",
        사업자등록증,
        org_code,
        계약시작일 = "",
        계약종료일 = "",
        status,
      } = org;

      this.state = {
        onSaving: false,
        is_new: false,
        isReadyToSubmit: true,
        addressModalIsOpen: false,
        data: {
          기관명,
          대표자이름,
          대표전화,
          사업장주소,
          대표이메일,
          비밀번호,
          org_code,
          계약시작일,
          계약종료일,
          사업자등록증,
          status,
        },
        verification: {
          기관명State: "success",
          대표자이름State: "success",
          대표전화State: "success",
          사업장주소State: "success",
          대표이메일State: "success",
          비밀번호State: "success",
          org_codeState: "success",
          사업자등록증State: "success",
          계약시작일State: "success",
          계약종료일State: "success",
        },
        filename: 사업자등록증 ? getFirebaseStorgeFilenameFromURL(사업자등록증) : ''
      }
    } else {
      this.state = {
        onSaving: false,
        is_new: true,
        isReadyToSubmit: false,
        addressModalIsOpen: false,
        data: {
          기관명: "",
          대표자이름: "",
          대표전화: "",
          사업장주소: "",
          대표이메일: "",
          org_code: "",
          사업자등록증: "",
          계약시작일: "",
          계약종료일: "",
          status: ORG_STATUS.WAITING_FOR_REVIEW,
          비밀번호: ""
        },
        verification: {
          기관명State: "",
          대표자이름State: "",
          대표전화State: "",
          사업장주소State: "",
          대표이메일State: "",
          org_codeState: "",
          사업자등록증State: "",
          계약시작일State: "",
          계약종료일State: "",
          비밀번호State: "",
        },
      }
    }
  }

  componentDidMount() {
  }

  handleAddress = (returnData) => {
    let fullAddress = returnData.address;
    let extraAddress = '';

    if (returnData.addressType === 'R') {
      if (returnData.bname !== '') {
        extraAddress += returnData.bname;
      }
      if (returnData.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${returnData.buildingName}` : returnData.buildingName);
      }
      fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
    }

    const { data, verification } = this.state;
    data["사업장주소"] = fullAddress;
    data["우편번호"] = returnData.zonecode;
    data["시군구코드"] = returnData.sigunguCode;
    data["시도코드"] = returnData.sigunguCode.substring(0, 1);
    verification["사업장주소State"] = "success";
    this.setState({
      addressModalIsOpen: false,
      data,
      verification,
    });

    console.log(JSON.stringify(returnData));  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  }

  onFileLoaded = (file) => {
    console.log(file);
    if (file.size > 5 * 1024 * 1024) {
      alert("파일 사이즈가 너무 큽니다. 5mb이하로 줄여서 올려주세요.");
      this.setState({ file: null });
      return;
    }
    const ext = _.last(file.name.split('.'));
    console.log("ext = ", ext);
    if (!['jpg', 'jpeg', 'png', 'pdf'].includes(ext.toLowerCase())) {
      alert("파일 형식을 확인해주세요. 허용가능한 파일 형식: jpg, png, pdf");
      this.setState({ file: null });
      return;
    }
    const { verification } = this.state;
    verification["사업자등록증State"] = "success";
    this.setState({ file, verification }, () => this.checkReadyToSubmit());
  }

  change = (event, stateName, typeInfo) => {
    // console.log('stateName = ', stateName);
    if (!typeInfo) {
      return;
    }

    const { type, params } = typeInfo;

    if (!type) {
      return;
    }

    let verified = true;
    switch (type) {
      case "email":
        verified = verifyEmail(event.target.value);
        break;
      case "phone":
        verified = verifyPhoneNumber(event.target.value);
        break;
      case "length":
        verified = verifyLength(event.target.value, params);
        break;
      case "number":
        verified = verifyNumber(event.target.value, params);
        break;
      default:
        break;
    }

    const { data, verification } = this.state;

    verification[`${stateName}State`] = verified ? "success" : "error";
    data[stateName] = event.target.value;

    this.setState({ data, verification }, () => this.checkReadyToSubmit());
  }

  checkReadyToSubmit = () => {
    console.log("state = ", this.state);
    let pass = true;
    Object.keys(this.state.verification).some(key => {
      if (this.state.verification[key] !== "success") {
        pass = false;
        return;
      }
    })

    if (!pass) {
      return this.setState({ isReadyToSubmit: false });
    }

    return this.setState({ isReadyToSubmit: pass });
  }

  save = async () => {
    const { file, data, verification } = this.state;

    const foundIndex = _.findIndex(verification, item => item === "error")
    if (foundIndex > -1) {
      alert("입력 값을 확인해주세요.");
      return Promise.reject(Error("입력 값을 확인해주세요."));
    }

    this.setState({ onSaving: true });

    // do upload
    if (file) {
      const path = `temp/business_licenses/${uuidv4()}`;
      console.log("storage path = ", path);
      try {
        const url = await uploadFile(file, path);
        data['사업자등록증'] = url;
      } catch (error) {
        console.error('사업자등록증 업로드 실패: ', error);
        this.props.showAlertAction({
          message: "사업자등록증 업로드에 실패했습니다.",
          color: 'danger',
        })
        this.setState({ onSaving: false });
      }
    }

    if (this.state.is_new) {
      console.log('data = ', data);
      try {
        await createOrg(data);
        this.props.showAlertAction({
          message: "기관이 등록되었습니다.",
          color: 'danger',
        })
        this.props.getOrgsAction();
        this.props.requestClose();
      } catch (error) {
        console.error('기관 등록 실패: ', error);
        this.props.showAlertAction({
          message: "기관 등록에 실패했습니다. 관리자에게 문의해주세요.",
          color: 'danger',
        })
      } finally {
        this.setState({ onSaving: false });
      }
    } else {
      try {
        await updateOrg(this.props.org.id, data)
        this.props.showAlertAction({
          message: "기관 정보가 갱신되었습니다.",
          color: 'danger',
        })
        this.props.getOrgsAction();
        this.props.requestClose();
      } catch (error) {
        console.error('기관정보 수정 실패: ', error);
        this.props.showAlertAction({
          message: "기관 정보수정에 실패했습니다. 관리자에게 문의해주세요.",
          color: 'danger',
        })
      } finally {
        this.setState({ onSaving: false });
      }
    }
  }


  render() {
    const { classes } = this.props;

    return (
      <Container>
        <Row>
          <Col>
            <CustomInput
              labelText="*기관명"
              success={this.state.verification["기관명State"] === "success"}
              error={this.state.verification["기관명State"] === "error"}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                value: this.state.data["기관명"],
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Icon className={classes.inputAdornmentIcon}>
                      business
                    </Icon>
                  </InputAdornment>
                ),
                onChange: event => this.change(event, "기관명", {
                  type: "length",
                  params: {
                    minLength: 2
                  }
                }),
                placeholder: "기관명"
              }}
            />
          </Col>
          <Col>
            <CustomInput
              labelText="*대표자이름"
              success={this.state.verification["대표자이름State"] === "success"}
              error={this.state.verification["대표자이름State"] === "error"}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                value: this.state.data["대표자이름"],
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Icon className={classes.inputAdornmentIcon}>
                      face
                    </Icon>
                  </InputAdornment>
                ),
                onChange: event => this.change(event, "대표자이름", {
                  type: "length",
                  params: {
                    minLength: 2
                  }
                }),
                placeholder: "대표자 이름"
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CustomInput
              labelText="*대표전화번호"
              success={this.state.verification["대표전화State"] === "success"}
              error={this.state.verification["대표전화State"] === "error"}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                value: this.state.data["대표전화"],
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Icon className={classes.inputAdornmentIcon}>
                      phone
                    </Icon>
                  </InputAdornment>
                ),
                onChange: event => this.change(event, "대표전화", {
                  type: "phone"
                }),
                placeholder: "대표 전화번호"
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col className='col-6'>
            <CustomInput
              labelText="*관리자 로그인용 이메일주소"
              success={this.state.verification["대표이메일State"] === "success"}
              error={this.state.verification["대표이메일State"] === "error"}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                disabled: !this.state.is_new,
                value: this.state.data["대표이메일"],
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Email className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                onChange: event => this.change(event, "대표이메일", {
                  type: "email"
                }),
                placeholder: "관리자 로그인용 이메일주소"
              }}
            />
          </Col>
          {
            this.state.is_new
              ? <Col>
                <CustomInput
                  labelText="관리자 암호(6글자 이상)"
                  id="email-login-password"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    value: this.state.data["비밀번호"],
                    onChange: event => this.change(event, "비밀번호", {
                      type: "length",
                      params: {
                        minLength: 6
                      }
                    }),
                  }}
                />
              </Col>
              : null
          }

        </Row>
        <Row>
          <Col>
            <CustomInput
              labelText="*사업장주소"
              success={this.state.verification["사업장주소State"] === "success"}
              error={this.state.verification["사업장주소State"] === "error"}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                value: this.state.data["사업장주소"],
                ref: el => this.addressForm = el,
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Icon className={classes.inputAdornmentIcon}>
                      home
                    </Icon>
                  </InputAdornment>
                ),
                onChange: event => this.change(event, "사업장주소", {
                  type: "length",
                  params: {
                    minLength: 8
                  }
                }),
                placeholder: "사업장 주소",
                onFocus: (e) => {
                  console.log("onFocus!!", e);
                  e.target.blur();
                  this.props.openAddressModal();
                }
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CustomInput
              labelText="*기관코드"
              success={this.state.verification["org_codeState"] === "success"}
              error={this.state.verification["org_codeState"] === "error"}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                value: this.state.data["org_code"],
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <Business className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                onChange: event => this.change(event, "org_code", {
                  type: "string"
                }),
                placeholder: "기관 코드(숫자4자리)"
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CustomInput
              labelText="계약시작일"
              success={this.state.verification["계약시작일State"] === "success"}
              error={this.state.verification["계약시작일State"] === "error"}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                value: this.state.data["계약시작일"],
                type: 'date',
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <DateRange className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                onChange: event => this.change(event, "계약시작일", {
                  type: "date"
                }),
                placeholder: "계약 시작일자를 선택해주세요"
              }}
            />
          </Col>
          <Col>
            <CustomInput
              labelText="계약종료일"
              success={this.state.verification["계약종료일State"] === "success"}
              error={this.state.verification["계약종료일State"] === "error"}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                value: this.state.data["계약종료일"],
                type: 'date',
                startAdornment: (
                  <InputAdornment
                    position="start"
                    className={classes.inputAdornment}
                  >
                    <DateRange className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                ),
                onChange: event => this.change(event, "계약종료일", {
                  type: "date"
                }),
                placeholder: "계약 종료일자를 선택해주세요"
              }}
            />
          </Col>
        </Row>
        <Row>
          {
            this.state.data["사업자등록증"]
              ? <Col className='mt-3 d-flex aligm-items-baseline justify-content-center'>
                <div className='d-flex align-items-center'>
                  <label>사업자 등록</label>
                  <Button
                    simple color='primary' onClick={() => window.open(this.state.data["사업자등록증"])}>
                    <Icon color='inherit'>attach_file</Icon>{this.state.filename || '사업자등록증'}
                  </Button>
                </div>
              </Col>
              : null
          }
          <Col className='mt-3'>
            <FileUpload onFileLoaded={this.onFileLoaded} buttonTitle={this.state.data["사업자등록증"] ? "새 사업자등록증 업로드" : "사업자등록증 첨부하기"} addButtonProps={{ color: "primary" }} />
          </Col>
        </Row>
        <Row>
          <Col className='col-4 offset-4'>
            <div className='text-center'>
              <label>현재 상태 </label>
              <CustomDropdown
                buttonText={ORG_STATUS_STRING[this.state.data["status"]]}
                hoverColor="info"
                buttonProps={{
                  round: true,
                  block: true,
                  color: "primary"
                }}
                dropPlacement="bottom"
                dropdownList={ORG_STATUS_STRING}
                onClick={(params) => {
                  const status = _.findIndex(ORG_STATUS_STRING, o => o == params);
                  const { data } = this.state;
                  data.status = status;
                  this.setState({ data });
                  console.log("params = ", params);
                  console.log("status = ", status);
                }}

              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Button className='btn-left' style={{ float: 'left' }} onClick={this.props.requestClose}>취소</Button>
            <Button className='btn-right' style={{ float: 'right' }} color="primary" onClick={this.save} disabled={!this.state.isReadyToSubmit || this.state.onSaving}>
              저장
              {this.state.onSaving ? <Spinner size="sm" color="light" /> : null}
            </Button>
          </Col>
        </Row>
      </Container >
    )
  }
}

OrgForm.propTypes = {
  classes: PropTypes.object.isRequired,
  org: PropTypes.object,
  requestClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(OrgForm);